<template>
  <div class="hints" @click="$store.commit('setHints', false)">
    <div class="center-hint">
      <p>
        Drag and <br />
        Pinch-To-Zoom to navigate the map
      </p>
      <img src="../assets/drag-hint.svg" />
    </div>
    <div class="top-right-hint">
      <img src="../assets/arrow-hint.svg" />
      <div class="hint-box">
        <p>
          Quickly jump to a <br />
          specific area on the map
        </p>
      </div>
    </div>
    <div class="background"></div>
  </div>
</template>
<script>
export default {
  name: "Hints",
};
</script>
<style lang="scss" scoped>
@import "../assets/styles/colors";
@import "../assets/styles/_breakpoints";
.hints {
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
}
.background {
  background: white;
  opacity: 0.3;
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  z-index: -1;
  width: 100%;
}
.center-hint {
  padding: 45px 80px;
  box-sizing: border-box;
  color: white;
  margin: 0 !important;
  background: $orange;
  border-radius: 28px;
  width: 315px;
  height: 238px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    animation: handAnimation 2s ease-out infinite;
  }
  p {
    //max-width: 160px;
    margin-bottom: 25px;
  }
  @include media("<=tablet") {
    padding: 10px;
    width: 70%;
    height: auto;
  }
}
@keyframes handAnimation {
  0% {
    transform: translate(-10px, 0);
  }
  25% {
    transform: translate(0, 10px);
  }
  50% {
    transform: translate(10px, 0);
  }
  75% {
    transform: translate(0, -10px);
  }
  100% {
    transform: translate(-10px, 0);
  }
}
.top-right-hint {
  position: absolute;
  z-index: 1;
  right: 80px;
  top: 90px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .hint-box {
    color: white;
    background: $orange;
    border-radius: 28px;
    padding: 45px;
    max-width: 315px;
    align-self: flex-start;
    margin-top: 20px;
    box-sizing: border-box;
    @include media("<=tablet") {
      padding: 20px;
      margin-top: 0;
    }
  }
  img {
    animation: arrowAnimation 0.7s ease forwards 1s;
    clip-path: polygon(0 100%, 0 100%, 0 100%, 0% 100%);
    margin: 0 !important;
  }
}
@keyframes arrowAnimation {
  to {
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0% 100%);
  }
}
</style>
